import { gql } from "lib/apolloClient";
import {
  organizationResourceFragment,
  organizationChildResourceFragment,
} from "Administrator/routes/AdminEducatorCenterV2/modules/AdminEducatorCenterV2Fragments.js";

export const getOrganizationResourcesFeedQuery = gql`
  query getOrganizationResourcesFeed(
    $parentId: ID!
    $parentType: ENTITY_TYPE_ENUM!
    $organizationResourceFilter: OrganizationResourceFilter
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $after: String
    $first: Int
  ) {
    node(id: $parentId, type: $parentType) {
      id
      ... on Organization {
        id
        organizationResourcesV2(
          filters: $organizationResourceFilter
          orderBy: $orderBy
          orderByDirection: $orderByDirection
          first: $first
          after: $after
        ) {
          resourceTypeBasedCount {
            fileCount
            folderCount
            totalCount
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              ...organizationResourceItem
            }
          }
        }
      }
    }
  }
  ${organizationResourceFragment.organizationResource}
`;

export const getOrganizationFolderResourcesQuery = gql`
  query getOrganizationFolderResources(
    $id: ID!
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $filters: OrganizationResourceFilter!
    $after: String
    $first: Int
  ) {
    node(id: $id, type: ORGANIZATION_RESOURCE) {
      ...organizationChildResourceItemV2
    }
  }
  ${organizationChildResourceFragment.childResourceFragmentV2}
`;

export const getUserCountByEntityCourseWithEntityIds = gql`
  query userCountByEntityCourseWithEntityIds(
    $organizationId: ID!
    $input: UserCountByEntityInput!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        users {
          userCountByEntity(input: $input) {
            totalCount
            staffCount
            studentCount
            familyCount
          }
        }
      }
    }
  }
`;

export const getUserGradesQuery = gql`
  query getUserGrades(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $allGradesFilters: AllGradesFilters
    $organizationId: ID
  ) {
    node(id: $id, type: $type) {
      id
      ... on Student {
        id
        allGrades(filters: $allGradesFilters) {
          id
          name
          globalGrade {
            id
            uid
            name
          }
        }
      }
      ... on Staff {
        id
        allGrades(filters: $allGradesFilters) {
          id
          name
          globalGrade {
            id
            uid
            name
          }
        }
      }
      ... on FamilyMember {
        id
        children(organizationId: $organizationId) {
          allGrades(filters: $allGradesFilters) {
            id
            name
            globalGrade {
              id
              uid
              name
            }
          }
        }
      }
    }
  }
`;

export const getStaffListForFiltersQuery = gql`
  query getStaffListForFilters(
    $organizationId: ID!
    $archivalState: ARCHIVAL_STATE_ENUM
    $curriculumProgramIds: [ID!]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        staff(
          filters: {
            archivalState: $archivalState
            curriculumProgramIds: $curriculumProgramIds
          }
        ) {
          totalCount
          edges {
            node {
              id
              firstName
              middleName
              lastName
              profileImage
            }
          }
        }
      }
    }
  }
`;
